<template>
  <el-select
    v-model="value"
    multiple
    class="mr-1"
    :placeholder="title"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in items"
      :key="item.id"
      :label="item.attributes.title"
      :value="Number(item.id)"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'WhiteListsSelector',
  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const update = (newValue: any) => {
      context.emit('update:modelValue', newValue)
    }

    const value = ref(props.modelValue)

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { update, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
